import { Injectable, OnDestroy } from '@angular/core';
import { StorageService } from '@ebootis/utilities';
import { iif, Observable, of, Subject } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { AvailableConfigurations } from '../../services/Ebootis.Queries/AvailableConfigurations';
import { Configuration } from '../../services/Ebootis.Queries/Configuration';
import { LobByOid } from '../../services/Ebootis.Queries/LobByOid';

@Injectable({
	providedIn: 'root',
})
export class ConfigurationService implements OnDestroy {

	private m_subscriptionsSubject = new Subject();
	private m_configurationSubject: Subject<Configuration.Result> = new Subject();
	private m_cfgInstance: Configuration.Result;
	constructor(
		private m_configurations: AvailableConfigurations,
		private m_currentConfiguration: Configuration,
		private m_lobByOid: LobByOid,
		private storageService: StorageService
	) {
	}

	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.complete();
	}

	/**
	 * Getter für die OID der ZBS Konfiguration aus dem LocalStorage.
	 */
	get SelectedConfigOid(): string {
		return this.storageService.getItem('local', 'ZBSconfig');
	}

	/**
	 * Liefert Liefert das Ergebnis des Queries für AvailableConfigurations zurück. Liste der verfügbaren Konfigurations.
	 */
	public getConfigurations(): Observable<AvailableConfigurations.Result[]> {
		return this.m_configurations.query();
	}
	public getConfiguration(): Observable<Configuration.Result> {
		if (!this.m_cfgInstance) {
			this._getConfiguration().subscribe();
			return this.m_configurationSubject.asObservable();
		} else {
			return of(this.m_cfgInstance);
		}
	}

	/**
	 * Setzt die OID der ausgewählten Konfiguration in den LocalStorage. Ruft die Methode _getConfiguration auf.
	 * @param p_oid OID der ausgewählten Konfiguration
	 */
	public setConfiguration(p_oid: string): void {
		this.storageService.setItem('local', 'ZBSconfig', p_oid);
		this._getConfiguration().subscribe();
	}

	/**
	 * Schreibt die aktuelle Konfiguration in eine lokale Instanz.
	 */
	private _getConfiguration(): Observable<any> {
		return iif(() => this.SelectedConfigOid != null, this.m_currentConfiguration.query({ oid: this.SelectedConfigOid }).pipe(take(1)).pipe(tap((config) => {
			this.m_cfgInstance = config;
			this.m_configurationSubject.next(config);
		})), of(null));
	}

	public getHelpDocument(): Observable<HelpDocument> {
		return this.getConfiguration().pipe(map((cfg) => {
			let helpDoc: HelpDocument = null;
			if (cfg != null && cfg.helpDoc != null) {
				helpDoc = {
					name: cfg.helpDoc.displayName,
					url: this.m_lobByOid.getLobUrl({ lob: cfg.helpDoc.oid })
				};
			}
			return helpDoc;
		}))
	}

	/**
	 * Entfernt die OID der ZBS Konfiguration aus dem LocalStorage.
	 */
	public removeConfigSelected(): void {
		this.storageService.removeItem('local', 'ZBSconfig');
		this.m_cfgInstance = null;
		this.m_configurationSubject.next(null);
	}
}


export interface HelpDocument {
	name: string;
	url: string;
}